import { render, staticRenderFns } from "./pdf-translator.vue?vue&type=template&id=b7a406da&"
import script from "./pdf-translator.vue?vue&type=script&lang=ts&"
export * from "./pdf-translator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports